
<div class="row">
  <div class="col-sm-12">
    <div style="float: right;">
      <button mat-raised-button class="pad-btn" [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (canAdd) {
          <button mat-menu-item (click)="add()" title="Add Templated Task">
            <mat-icon aria-hidden="false" aria-label="Add Templated Task">add</mat-icon>
            <span>Add Templated Task</span>
          </button>
        }
        @if (canAdd) {
          <button mat-menu-item (click)="migrate()" title="Migrate Templated Task">
            <mat-icon aria-hidden="false" aria-label="Migrate Templated Task">trending_flat</mat-icon>
            <span>Migrate Templated Task</span>
          </button>
        }
        <button mat-menu-item title="Export as CSV" (click)="exportAsCSV()">
          <mat-icon aria-hidden="false" aria-label="Export as CSV">file_download</mat-icon>
          <span>Export as CSV</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>

<div class="row pc-pt-wrapper">
  <div class="col-12" style="padding: 0;">
    <p-table
      [value]="tableRows"
      dataKey="id"
      [loading]="tableLoading"
      [scrollable]="true"
      scrollHeight="calc(100vh - 320px)"
      [rowHover]="true"
      sortField="name"
      [sortOrder]="1"
      styleClass="p-datatable-sm pc-tasklib-table">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-t>
        <tr class="pc-row"
            [class.pc-selected]="t.id === selectedId"
            [class.pc-locked]="selectionLocked && t.id !== selectedId"
            (click)="selectTask(t)">
          <td><span class="pc-name-text">{{ t.name }}</span></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        @if (tableRows.length > 0) {
          <tr class="pc-footer">
            <td class="pc-footer-label">
              {{ tableRows.length }} task{{ tableRows.length === 1 ? '' : 's' }}
            </td>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="pc-empty">{{ tableLoading ? 'Loading tasks…' : 'No tasks to show.' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
